import React, { Fragment } from "react";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PartnersContent from "./content";
import PartnersHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";
 
export default function Partners() {
    useDocumentTitle(
    "Merchant Onboarding - Documents Required | YOOZ",
    "Seamless and hassle-free Sign Up. Join over 100 Merchants who YOOZ It to grow sales by accepting payments with simplified solutions through multiple channels."
  );
  return (
    <Fragment>
      <ContentWrapper>
        <PartnersHeader />
        <PartnersContent />
      </ContentWrapper>
    </Fragment>
  );
}
